<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  }
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0">{{ title }}</h4>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>

          <!-- <div>
            <a class="popup-form btn btn-primary" href="javascript: void(0);" v-b-modal.popup-form>Add user</a>
          </div>
          <b-modal id="popup-form" hide-footer centered size="lg" title="Form">
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="name">Name</label>
                    <input type="text" class="form-control" id="name" placeholder="Enter Name" />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" class="form-control" id="email" placeholder="Enter Email" />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="password">Password</label>
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      placeholder="Enter Password"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label for="subject">Subject</label>
                    <textarea class="form-control" id="subject" rows="3"></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="text-right">
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </b-modal> -->
          <!-- Slot for custom button -->
          <slot name="header-button"></slot>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
